var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Banner } from "./Banner";
import { Login, loginHandles } from "./Login";
import { ForgotPassword, forgotPasswordHandles, } from "./ForgotYourPassword";
import { PasswordFlow, passwordFlowHandles, } from "./PasswordFlow";
import { createSession, getBearerToken } from "./api";
import { AuthenticationScreens } from "./data";
import { signInAuth } from "./handlers";
import { checkRegistrationHander, conifrmationSignIn, forgotPasswordHandler, ResetPassword, } from "./ForgotYourPassword/hanlders";
import { FTPSubmitHandler, handleCPWC } from "./PasswordFlow/handlers";
import { useCommonLoader } from "../Loader";
import AuthStyle from "./style";
const AuthenticationComponent = (props) => {
    const [config, setConfig] = useState(props.config);
    const [userInfo, setUserInfo] = useState({});
    const [session, setSession] = useState(false);
    const { awsConfig, bannerProps } = props;
    const { setLoading, unSetLoading } = useCommonLoader();
    useEffect(() => {
        setConfig(props.config);
        setSession(getBearerToken());
    }, [props.config]);
    const sessionCreation = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (session || getBearerToken())
            return Promise.resolve();
        try {
            yield createSession(props.appConfig);
            setSession(true);
            return Promise.resolve(session);
        }
        catch (error) {
            setSession(false);
            return Promise.reject(session);
        }
    }), [props.appConfig, session]);
    const LoginAuth = useCallback((data) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        setLoading();
        setUserInfo(Object.assign(Object.assign({}, userInfo), data));
        try {
            // creating session for user
            yield sessionCreation();
            // Authentication process
            const authResponse = yield signInAuth({
                appConfig: props.appConfig,
                userInfo: Object.assign(Object.assign({}, userInfo), data),
                UI: props.UI
            });
            // Update state with auth user info
            setUserInfo(Object.assign(Object.assign(Object.assign({}, userInfo), { authenticatedUser: authResponse }), data));
            // Next level Authentication process
            if (authResponse.nextAuth) {
                unSetLoading();
                return setConfig(authResponse.nextAuth);
            }
            // Invoking parent callback function once all process is done
            (_a = props === null || props === void 0 ? void 0 : props.authCallback) === null || _a === void 0 ? void 0 : _a.call(props, authResponse);
            // Passing promise to child component to get the result
            unSetLoading();
            return Promise.resolve({ message: "" });
        }
        catch (error) {
            unSetLoading();
            // Invoking parent callback function once all process is done
            // props?.authCallback?.(error);
            // Passing promise to child component to get the result
            return Promise.reject({
                message: error === null || error === void 0 ? void 0 : error.message,
                isAuthenticated: false,
            });
        }
    }), [userInfo, props, sessionCreation]);
    const forgotPassword = useCallback((data) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            // creating session for user
            yield sessionCreation();
            const forgotPasswordResponse = yield forgotPasswordHandler({
                appConfig: props.appConfig,
                awsConfig,
                userInfo: Object.assign(Object.assign({}, userInfo), data),
                UI: props.UI
            });
            console.log("==dsdsdsds====", forgotPasswordResponse);
            setUserInfo((userInfo) => (Object.assign(Object.assign(Object.assign({}, userInfo), data), { email: forgotPasswordResponse.email })));
            return Promise.resolve(forgotPasswordResponse);
        }
        catch (error) {
            return Promise.reject(error); // Passing promise to child component to get the result
        }
    }), [props.appConfig, userInfo, sessionCreation, setUserInfo, awsConfig]);
    // Forgot password
    const resendEmail = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const resetPassResponse = yield ResetPassword({
            appConfig: props.appConfig,
            awsConfig,
            email: userInfo.email,
        });
        return resetPassResponse;
    }), [userInfo, props.appConfig, awsConfig]);
    const otpHandler = useCallback((data) => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        try {
            const otpResponse = yield conifrmationSignIn({
                appConfig: props.appConfig,
                awsConfig,
                userInfo: Object.assign(Object.assign(Object.assign({}, userInfo), data), { ui: props === null || props === void 0 ? void 0 : props.UI }),
            });
            // Invoking parent callback function once all process is done
            return (_b = props === null || props === void 0 ? void 0 : props.authCallback) === null || _b === void 0 ? void 0 : _b.call(props, otpResponse);
        }
        catch (error) {
            // Passing promise to child component to get the result
            return Promise.reject({
                message: error === null || error === void 0 ? void 0 : error.message,
                isAuthenticated: false,
            });
        }
    }), [props.authCallback, userInfo, awsConfig, props.appConfig]);
    const authentication = useCallback((data) => __awaiter(void 0, void 0, void 0, function* () {
        console.log("=====", userInfo, data);
        console.log("=====config", config);
        switch (config) {
            case AuthenticationScreens.login:
                setUserInfo(Object.assign(Object.assign({}, userInfo), data));
                return LoginAuth(data);
            case AuthenticationScreens.FP:
                setUserInfo(Object.assign(Object.assign({}, userInfo), data));
                // Forgot Password -> Forced change password in respone -> Resend Email Dialog
                if (data.resendEmail)
                    return resendEmail();
                return forgotPassword(data);
            case AuthenticationScreens.CPWC:
                setUserInfo(Object.assign(Object.assign({}, userInfo), data));
                return handleCPWC({ userInfo: Object.assign(Object.assign({}, userInfo), data) });
            case AuthenticationScreens.FTP:
                return FTPSubmitHandler(Object.assign(Object.assign({}, userInfo), data));
            case AuthenticationScreens.CR:
                yield sessionCreation();
                return checkRegistrationHander({
                    appConfig: props.appConfig,
                    awsConfig,
                    userInfo: Object.assign(Object.assign({}, userInfo), data),
                });
            case AuthenticationScreens.OTP:
                if (data.resend)
                    return LoginAuth({});
                return otpHandler(data);
            default:
                break;
        }
    }), [
        config,
        LoginAuth,
        forgotPassword,
        userInfo,
        setUserInfo,
        resendEmail,
        otpHandler,
    ]);
    const changeConfig = (config) => config && setConfig(config);
    const childrenProps = useMemo(() => ({
        config,
        authenticationFlow: authentication,
        changeConfig,
        appConfig: props.appConfig,
        userInfo,
        UI: props.UI
    }), [config, authentication, props.appConfig, userInfo]);
    console.clear();
    console.log("=========", childrenProps);
    return (React.createElement(AuthStyle, { className: `auth-wrapper-${props.UI}` },
        React.createElement("div", { className: `auth-wrapper auth-wrapper_${props.appConfig.brand}` },
            React.createElement(Banner, Object.assign({}, bannerProps, { UI: props.UI })),
            React.createElement("section", null,
                loginHandles.includes(config) && (React.createElement(Login, Object.assign({}, childrenProps))),
                forgotPasswordHandles.includes(config) && (React.createElement(ForgotPassword, Object.assign({}, childrenProps))),
                passwordFlowHandles.includes(config) && (React.createElement(PasswordFlow, Object.assign({}, childrenProps)))))));
};
export const Authentication = React.memo(AuthenticationComponent);
